<template>
    <b-modal :id="$attrs.id || modalId" :title="title" no-close-on-backdrop no-close-on-esc
        :header-class="showTabs ? 'p-b-0' : ''" @hidden="closeModal">

        <template #modal-header="{ close }">
            <!-- Tabs (if enabled) -->
            <b-tabs v-if="showTabs" v-model="tabIndex" pills nav-class="w-100">
                <b-tab title="Iniciar sesión" @click="mode = 'login'"></b-tab>
                <b-tab title="Crear cuenta" @click="mode = 'register'"></b-tab>
            </b-tabs>
            <button type="button" class="close" @click="close()">×</button>
        </template>

        <!-- B-Form -->
        <b-form @submit.prevent="tryProcess">

            <!-- Login Form -->
            <template v-if="mode === 'login'">
                <b-form-group label="Correo electrónico" label-for="login-email">
                    <b-form-input v-model="data.login.email" id="login-email" type="email" required :readonly="data.login.lockEmail"
                        @keyup.enter="tryProcess" />
                </b-form-group>
                <b-form-group label="Contraseña" label-for="login-password">
                    <b-form-input v-model="data.login.password" id="login-password" type="password" :readonly="data.login.lockEmail" required
                        @keyup.enter="tryProcess" />
                </b-form-group>
                <b-row align-h="end">
                    <b-col class="text-right">
                        <b-button variant="link" class="p-0" @click="showModalForgotPassword">
                            ¿Olvidaste tu contraseña?
                        </b-button>
                    </b-col>
                </b-row>
            </template>

            <!-- Register -->
            <template v-else-if="mode === 'register'">
                <b-row>
                    <b-col>
                        <b-form-group label="Nombre" label-for="register-nombre">
                            <b-form-input id="register-nombre" v-model="data.register.nombre" type="text" required
                                @keyup.enter="tryProcess" />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Apellidos" label-for="register-apellidos">
                            <b-form-input id="register-apellidos" v-model="data.register.apellidos" type="text" required
                                @keyup.enter="tryProcess" />
                        </b-form-group>
                    </b-col>
                </b-row>


                <b-form-group label="CURP" label-for="register-curp">
                    <b-form-input id="register-curp" v-model="data.register.curp" type="text" required
                        @keyup.enter="tryProcess" />
                </b-form-group>

                <b-row>
                    <b-col>
                        <b-form-group label="Correo electrónico" label-for="register-email" class="mb-0">
                            <b-form-input id="register-email" v-model="data.register.email" type="email" required
                                @keyup.enter="tryProcess" />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Teléfono o ICCID" label-for="register-telefono" class="mb-0">
                            <b-form-input id="register-telefono" v-model="data.register.telefonoICCID" type="tel" required
                                @keyup.enter="tryProcess" />
                            <b-form-text class="text-muted text-left pt-1">
                                <i class="fa fa-info-circle fa-2x fa-pull-left fa-border" aria-hidden="true"></i>
                                Encuéntralo en tu chip <b class="text-primary nowrap">Clave Verde</b>
                            </b-form-text>
                        </b-form-group>
                    </b-col>
                </b-row>

                <hr>

                <b-row>
                    <b-col>
                        <b-form-group label="Contraseña" label-for="register-password">
                            <b-form-input id="register-password" v-model="data.register.password" type="password"
                                required @keyup.enter="tryProcess" />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Confirmar Contraseña" label-for="register-confirm-password">
                            <b-form-input id="register-confirm-password" v-model="data.register.confirmPassword"
                                type="password" :disabled="!data.register.password" required
                                @keyup.enter="tryProcess" />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-form-group class="mb-0">
                    <b-form-checkbox id="register-tyc" v-model="data.register.tyc" required>
                        Acepto los
                        <router-link :to="{ name: 'TermsAndConditions' }" target="_blank">
                            términos y condiciones
                        </router-link>
                    </b-form-checkbox>
                </b-form-group>

            </template>

            <!-- Forgot Password -->
            <template v-else-if="mode === 'forgot-password'">

                <!-- Recovery mode select -->
                <b-form-group label="Modo de recuperación" label-for="recovery-mode-select">
                    <b-form-select id="recovery-mode-select" v-model="recoveryStage.recoveryMode" :options="[
                        { value: 'email', text: 'Correo electrónico' },
                        { value: 'phone', text: 'Teléfono' }
                    ]" />
                </b-form-group>

                <!-- Recovery by email -->
                <b-form-group v-if="recoveryStage.recoveryMode === 'email'" label="Correo electrónico"
                    label-for="forgot-email">
                    <b-form-input id="forgot-email" v-model="recoveryStage.email" type="email" required
                        :disabled="recoveryStage.pinSent" @keyup.enter="tryProcess" />
                    <b-form-text class="text-muted">Se enviará un PIN a tu correo electrónico.</b-form-text>
                </b-form-group>

                <!-- Recovery by phone -->
                <b-form-group v-if="recoveryStage.recoveryMode === 'phone'" label="Teléfono" label-for="forgot-phone">
                    <b-form-input id="forgot-phone" v-model="recoveryStage.phone" type="tel" required
                        :disabled="recoveryStage.pinSent" @keyup.enter="tryProcess"
                        placeholder="Introduce tu número de teléfono" />
                    <b-form-text class="text-muted">Se enviará un PIN a tu teléfono.</b-form-text>
                </b-form-group>

                <!-- PIN input -->
                <b-form-group v-if="recoveryStage.pinSent" label="PIN" label-for="forgot-pin">
                    <b-form-input id="forgot-pin" v-model="recoveryStage.codigo" type="text" maxlength="6"
                        inputmode="numeric" pattern="\d{6}" placeholder="Introduce el PIN de 6 dígitos" required
                        :disabled="recoveryStage.verified"
                        @keyup.enter="tryProcess" />
                    <b-form-text class="text-muted">Introduce el código de 6 dígitos enviado a tu correo.</b-form-text>
                </b-form-group>

                <!-- New password inputs -->
                <template v-if="recoveryStage.verified">
                    <b-form-group label="Nueva Contraseña" label-for="forgot-new-password">
                        <b-form-input id="forgot-new-password" v-model="recoveryStage.password" type="password" required
                            @keyup.enter="tryProcess" />
                    </b-form-group>
                    <b-form-group label="Confirmar Nueva Contraseña"
                        label-for="forgot-confirm-new-password">
                        <b-form-input id="forgot-confirm-new-password" v-model="recoveryStage.password_confirmation" type="password"
                            required @keyup.enter="tryProcess" />
                    </b-form-group>
                </template>

            </template>

        </b-form>

        <template #modal-footer="{ cancel }">
            <b-button variant="warning" @click="cancel()">Cancelar</b-button>
            <lock-button variant="primary" :is-processing="isProcessing" @click="tryProcess">
                {{ procesLabel }}
            </lock-button>
        </template>

    </b-modal>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import { mapMutations } from 'vuex';

const emptyRecoveryStage = {
        recoveryMode: 'email', // 'email' | 'phone'
        email: '',
        phone: '',
        pinSent: false,
        verified: false,
        codigo: null,
        password: '',
        password_confirmation: '',
    },
    emptyRegisterForm = {
        nombre: '',
        apellidos: '',
        telefono: '',
        curp: '',
        tyc: false,
        email: '',
        password: '',
        confirmPassword: ''
    },
    emptyLoginForm = {
        email: '',
        lockEmail: false,
        password: ''
    };

export default {
    name: 'AccessForm',
    props: {
        showTabs: {
            type: Boolean,
            default: false
        },
        controller: {
            type: String,
            default: 'auth'
        },
        modalId: {
            type: String,
            default: 'modal-1'
        }
    },
    data: () => {
        return {
            mode: 'login', // 'login' | 'register' | 'forgot-password',
            tabIndex: 0,
            data: { register: { ...emptyRegisterForm }, login: { ...emptyLoginForm } },
            recoveryStage: _.clone(emptyRecoveryStage),
            isProcessing: false
        }
    },
    computed: {
        procesLabel() {
            return ((this.mode === 'login') ? 'Iniciar sesión' : ((this.mode === 'register') ? 'Crear cuenta' : 'Recuperar contraseña'));
        },
        recoveryStField() {
            let apiSubcConcept;
            if (!this.recoveryStage.pinSent) {
                apiSubcConcept = '';
            }
            else if (this.recoveryStage.pinSent && !this.recoveryStage.verified) {
                apiSubcConcept = 'validate_';
            }
            else {
                apiSubcConcept = 'reset_';
            }
            return apiSubcConcept + this.recoveryStage.recoveryMode;
        },
        preocessingData() {
            switch (this.mode) {
                case 'login':
                    return this.data.login;
                case 'forgot-password':
                    return this.recoveryStage; // Add forgot-password data if needed
                default:
                    return this.data.register;
            }
        },
        processingURL() {
            let mode = this.mode;   
            switch (this.mode) {
                // Note: The backend endpoint is different for password recovery
                case 'forgot-password':
                    return 'index.php?r=claveverde/password/' + this.recoveryStField;
                default:
                    return 'index.php?r=claveverde/' + this.controller + '/' + mode;
            }
        },
        title() {
            switch (this.mode) {
                case 'login':
                    return 'Iniciar sesión';
                case 'register':
                    return 'Crear cuenta';
                case 'forgot-password':
                    return 'Recuperar contraseña';
                default:
                    return '';
            }
        }
    },
    methods: {
        ...mapMutations(['authUpdate']),
        async tryProcess() {
            this.isProcessing = true;
            try {
                const response = await axios.post(this.processingURL, this.preocessingData);

                if (response.status && this.mode === 'forgot-password')
                    this.processPassRecovery(response);

                else if (response.status)
                    this.loginSuccessful({ user: response.data });

            } catch (error) {
                console.error(error);
            } finally {
                this.isProcessing = false;
            }
        },
        processPassRecovery(response) {
            if (response.status && this.recoveryStage.pinSent === false) {
                // Populate email field if returned by API
                if(response.data.email){
                    this.data.login = _.clone(emptyLoginForm);
                    this.data.login.lockEmail = true;
                    this.data.login.email = response.data.email;
                }
                // First stage: email sent
                this.recoveryStage.pinSent = true;
            } else if (response.status && this.recoveryStage.verified === false) {
                // Second stage: PIN verified
                this.recoveryStage.verified = true;
            } else if(response.status) {
                // Final stage: password reset successful
                this.mode = 'login';
                this.data.login.password = this.recoveryStage.password;
                this.tryProcess()
            }
        },
        loginSuccessful(userData) {
            this.authUpdate(userData);
            this.closeModal();
            this.$router.replace({ name: 'MyAccount' });
        },
        showModalLogin() {
            this.mode = 'login';
            this.showModal();
        },
        showModalRegister() {
            this.mode = 'register';
            this.showModal();
        },
        showModalForgotPassword() {
            this.mode = 'forgot-password';
            this.showModal();
        },
        showModal() {
            this.$bvModal.show(this.$attrs.id || this.modalId);
        },
        closeModal() {
            this.$bvModal.hide(this.$attrs.id || this.modalId);
            this.data.register = { ...emptyRegisterForm };
            this.data.login = { ...emptyLoginForm };
            this.recoveryStage = _.clone(emptyRecoveryStage);
        }
    }
};
</script>